// =============================================================================
// Dropdown — click toggle, keyboard (Enter/Space), ESC + click-outside close.
// Hover is handled by CSS on desktop.
// =============================================================================
(function ($) {
    'use strict';

    $(function () {
        const $dropdowns = $('[data-dropdown]');
        if (!$dropdowns.length) { return; }

        function closeAll(except) {
            $dropdowns.each(function () {
                if (this === except) { return; }
                $(this).removeClass('is-open')
                    .find('[data-dropdown-trigger]').attr('aria-expanded', 'false');
            });
        }

        $(document).on('click', '[data-dropdown-trigger]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const $wrap = $(this).closest('[data-dropdown]');
            const wasOpen = $wrap.hasClass('is-open');
            closeAll($wrap[0]);
            $wrap.toggleClass('is-open', !wasOpen);
            $(this).attr('aria-expanded', wasOpen ? 'false' : 'true');
        });

        // Clicks inside the panel don't bubble to document close.
        $(document).on('click', '[data-dropdown-panel]', (e) => { e.stopPropagation(); });

        $(document).on('click', () => { closeAll(null); });

        $(document).on('keydown', (e) => {
            if (e.key !== 'Escape') { return; }
            const $open = $dropdowns.filter('.is-open');
            if (!$open.length) { return; }
            $open.each(function () {
                $(this).removeClass('is-open')
                    .find('[data-dropdown-trigger]').attr('aria-expanded', 'false').trigger('focus');
            });
        });
    });
})(jQuery);
